import { useIntl } from "react-intl";
import styles from "./Drivers.module.scss";

export const Drivers = () => {
  const intl = useIntl();

  return (
    <div className={styles.drivers}>
      <div className={styles.label}>
        {intl.formatMessage({ id: "drivers" }, { nb: 2 })}
      </div>
      <div className={styles.placeholder} />
    </div>
  );
};
